import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UnknownSecurities } from "src/pages/Admin/UnknownSecurities/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function getUnknownSecuritiesRequest(name: string, exchange: string, type: string) {
	return await apiClient
		.get(API.QUERY.ADMIN.UNKOWN_SECURITIES, { params: { name, exchange, type } })
		.then((res) => res.data);
}

export function useGetUnknownSecurities(name: string, exchange: string, type: string) {
	return useQuery<UnknownSecurities[], AxiosError>({
		queryKey: ["adminUnknownSecurities", name, exchange, type],
		queryFn: () => getUnknownSecuritiesRequest(name, exchange, type)
	});
}

export async function getUnknownFundsRequest(
	term: string,
	includeNullManagementCompany: boolean,
	includeNullTaxExempt: boolean,
	page: number,
	size: number
) {
	return await apiClient
		.get(API.QUERY.ADMIN.UNKNOWN_FUNDS, {
			params: { term, includeNullManagementCompany, includeNullTaxExempt, page, size }
		})
		.then((res) => res.data);
}
